module.exports = __webpack_public_path__ + "static/media/profile-photo.7548ded1.jpg";